import React from 'react';

import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import cx from 'classnames';

interface ITooltipOptions {
  Component: JSX.Element;
  tooltipText: React.ReactNode;
  placement?: TooltipPlacement;
  classes?: string[];
  mouseEnterDelay?: number;
  trigger?: string | string[];
  hideTooltip?: boolean;
}

export const SxTooltip = ({
  Component,
  tooltipText = '',
  placement = 'bottom',
  classes = [],
  mouseEnterDelay = 0.5,
  trigger = ['hover'],
  hideTooltip = false
}: ITooltipOptions): JSX.Element | null => {
  if (!Component) {
    return null;
  }

  if (hideTooltip || !tooltipText) {
    return Component;
  }

  const options = {
    title: tooltipText,
    placement,
    overlayClassName: cx('tooltip-content', ...classes),
    mouseEnterDelay,
    trigger
  };

  return (
    <Tooltip
      {...options }
      getPopupContainer={(triggerElement) => trigger === 'click' ? triggerElement.parentElement || document.body : document.body}
    >
      {Component}
    </Tooltip>
  );
};
